import styled from 'styled-components';
import { COLOR_WHITE } from 'constants/colors';
import {
  Form,
} from 'antd';
import {
  Collapse,
} from 'UI';

export const ToggledCollapse = styled(Collapse)`
  width: 100%;

  .ant-collapse-header {
    visibility: collapse;
    height: 0;
  }

  &.ant-collapse > .ant-collapse-item > .ant-collapse-header {
    padding: 0;
  }
`;

export const FormContainer = styled(Form)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background-color: ${COLOR_WHITE};
  padding: 1.5rem;
  width: 100%;
`;

export const BaseFormItem = styled(Form.Item)`
  margin: 0;
  width: 100%;
  padding-bottom: 1.5rem;

  & .ant-col,
  & .ant-form-item-control {
    width: 100%;
    max-width: 376px;
  }
`;
